import React from "react";
import { createRoot } from "react-dom/client";
import ThingsILoveApp from "../things_i_love_single_file_react_app.jsx";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element found");
createRoot(root).render(<ThingsILoveApp />);
